import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserManagementServiceService } from '../user-management-service.service';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.scss']
})
export class ManageUserComponent implements OnInit {
  tableHeading = [
    {title: '', code: 'Name', key: 'name' , subKey: '', type: 'text', sort: true, isClickable: true},
    {title: '', code: 'User Role', key: 'role.name' , subKey: 'name', type: 'text', sort: true, isClickable: false},
    {title: '', code: 'Email', key: 'email' , subKey: '', type: 'text', sort: false, isClickable: false},
    {title: '', code: 'Country', key: 'country.name' , subKey: 'name', type: 'text', sort: true, isClickable: false, imageKey: true},
    {title: '', code: 'Sector', key: 'sector.name' , subKey: 'name', type: 'text', sort: true, isClickable: false},
    {title: '', code: 'Msme', key: 'msme.name' , subKey: 'name', type: 'text', sort: true, isClickable: false},
    {title: '', code: 'Employee Count', key: 'employeeCount' , subKey: 'name', type: 'text', sort: false, isClickable: false},
    {title: '', code: 'MSME Type', key: 'msme_classification.type' , subKey: 'name', type: 'text', sort: false, isClickable: false},
    {title: '', code: 'MSME Active', key: 'is_msme_user_active', type: 'booleanToggle', sort: false, isClickable: false},
    {title: '', code: 'Creation Date', key: 'createdAt' , subKey: '', type: 'date', sort: true, isClickable: false},
    {title: '', code: 'Actions', key: 'action' , subKey: '', type: 'text', sort: false, isClickable: false},
  ];
  totalCount = 0;
  tableData: any;
  manageUsertableData: any = [];
  action = [
    {
      actionType: 'edit', icon: 'fa fa-edit', disabled: false, toolTip: 'Edit',
      imgIcon: '../../../../assets/images/edit.svg', isPermission: false, label: 'Update', key: 'update'
    },
    {
      actionType: 'delete', icon: 'fa fa-trash', disabled: false, toolTip: 'Delete',
      imgIcon: '../../../../assets/images/delete-bin.svg', isPermission: false, label: 'Delete', key: 'update'
    },
    {
      actionType: 'view', icon: 'fa fa-eye', disabled: false, toolTip: 'View',
      imgIcon: '../../../../assets/images/view-icon.svg', isPermission: true, label: 'View', key: 'view'
    },
  ];
  allowedAction: any;
  constructor(
    private router: Router,
    private userManagementService: UserManagementServiceService,
    private snackBar: MatSnackBar,
  ) {
    const pageAction = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
    this.allowedAction = pageAction[0].authenicationJson.filter((el: any) => {
      if (el?.model === 'user') { return el; }
    });
  }

  ngOnInit(): void {
    this.action = this.userManagementService.actionTablePermission(this.action, this.allowedAction[0]);
    this.getAllUser();
  }

  getAllUser(page = 1, limit= 10, orderSorting: string= '', columnName: string= ''): void{
    this.userManagementService.allUserDetails(page, limit, orderSorting, columnName).subscribe((res: any) => {
      if (res.success){
        this.manageUsertableData = JSON.parse(JSON.stringify(res.data));
        this.totalCount = res.total ? res.total : 0;
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , 3000);
    });
  }
  onMsmeActiveChange(event: { data: any; value: boolean }): void {
    const payload = { ...event.data, is_msme_user_active: event.value };
    this.userManagementService.updateUser(String(event.data.id), payload).subscribe(
      (res: any) => {
        this.openSnackBar([res?.message || 'User updated successfully'], 3000);
        if (res?.success) {
          this.updateRowMsmeActive(event.data.id, event.value);
        } else {
          this.updateRowMsmeActive(event.data.id, !event.value);
        }
      },
      (err: any) => {
        this.updateRowMsmeActive(event.data.id, !event.value);
        this.openSnackBar([err?.message || 'Failed to update'], 3000);
      }
    );
  }

  private updateRowMsmeActive(userId: number, value: boolean): void {
    this.manageUsertableData = this.manageUsertableData.map((u: any) =>
      u.id === userId ? { ...u, is_msme_user_active: value } : u
    );
  }

  tableAction(data: any, action: string): void {
    if (action === 'edit') {
      this.router.navigate(['/add-user', data.id]);
    }
    if (action === 'delete') {
      this.deleteUser(data);
    }
    if (action === 'view'){
      const queryParams = {
        mode : 'view'
      };
      this.router.navigate(['/add-user', data.id], { queryParams });
    }
  }

  deleteUser(data: any): void {
    const body = data;
    body.isActive = false;
    this.userManagementService.deleteByUserId(data?.id, body).subscribe((res: any) => {
      if (res.success){
        this.openSnackBar([ 'Deleted Successfully '] , 3000);
        const page = data?.page ? data?.page : 1;
        this.getAllUser(page);
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , 3000);
    });
  }
  pageHandler(event: any): void{
    this.getAllUser(event?.page, event?.limit, event?.orderSorting, event?.key);
  }
  clearSearchBox(event: any): void {
    this.getAllUser();
  }
  openSnackBar(data: string[], duration: number): void {
    this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
  }
  sortTable(event: any): void {
    this.getAllUser(event.page, 10, event?.orderSorting, event?.key);
  }
}
